module.exports = __webpack_public_path__ + "static/header-ad2ad939aae55a4a0fb725f7ec7f0b6c.png";